import { l10nService } from '@/utils/apis'
export async function getTranslations(lang: string) {
  return l10nService.findListOfTexts({ lang })
}
